import { render, staticRenderFns } from "./LettersEditComponent.vue?vue&type=template&id=22ee48c8&scoped=true"
import script from "./LettersEditComponent.vue?vue&type=script&lang=js"
export * from "./LettersEditComponent.vue?vue&type=script&lang=js"
import style0 from "./LettersEditComponent.vue?vue&type=style&index=0&id=22ee48c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee48c8",
  null
  
)

export default component.exports